import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import './Managemerchant.scss';
import DataTable from '../../../shared/tables/DataTable';
import CustomPagination from '../../../shared/pagination/CustomPagination';
import { CREATE_ACC_COLOUMNS, BUSINESSES_TEXT, MANAGE_MERCHANTS } from '../../../constants/Admin/adminConstants';
import { useDispatch, useSelector } from 'react-redux';
import { saveAggregatorValues,activebrandnames, activebrandid, getmerchantsInfoRequest, activelocations, activelocationslist, activebusinessname } from '../../../redux/actions/adminFlow/merchantInfoAction';
import { merchantInfoDataSaga, merchantInfoDataErrorSaga } from '../../../redux/saga/adminFlow/merchantInfoSelector';
import CreateAccountButton from '../createaccount/createaccountbutton/createaccountbutton';
import LocationsModal from '../createaccount/locationsmodal/LocationsModal';
import { handleSortingInTable } from '../../../shared/utils/format.helpers';
import { createAccountSuccess, createAccountFailure } from '../../../redux/actions/adminFlow/createAccountAction';
//import { merchantsInfoRowMockData_new, addressMockData } from '../../../mockData/manageMerchantsMockData';
import { getViewLocationDetailsRequest } from '../../../redux/actions/transactionActions';
import { viewLocationDetailsSaga, viewLocationDetailsErrorSaga } from '../../../redux/saga/transactionSelectors';


const  ManageMerchant = () => {

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const merchantsdata =  useSelector(merchantInfoDataSaga);
	const merchantsdataerror = useSelector(merchantInfoDataErrorSaga);
	const viewLocationDetails = useSelector(viewLocationDetailsSaga);
	const viewLocationDetailsError = useSelector(viewLocationDetailsErrorSaga);

	const [totalNumberOfElements, setTotalNumberOfElements] = useState(0);
	const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
	const [currentPageNumber, setCurrentPageNumber] = useState(0);
	const [numberOfElementsonThisPage, setNumberOfElementsonThisPage] = useState(10);
	const [modalOpen, setModalOpen] = useState(false);
	const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'Descending' });
	const [shouldOpenModal, setShouldOpenModal] = useState(false);

	const handleOpenModal = () => {
		setModalOpen(true);
	};
	
	const handleCloseModal = () => {
		setModalOpen(false);
		setShouldOpenModal(false);
	};

	useEffect(() => {
		if (shouldOpenModal && viewLocationDetails && viewLocationDetails.data) {
			handleOpenModal();
		}
	}, [viewLocationDetails, shouldOpenModal, dispatch]);

	const handleChangePage = (event, newPage) => {
		setCurrentPageNumber(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setNumberOfElementsonThisPage(parseInt(event.target.value, 10));
		setCurrentPageNumber(0);
	};

	const handleSort = (columnKey) => {
		handleSortingInTable(columnKey, sortConfig, setSortConfig );
	};

	const handleCreateAccountClick2 = ()=>{
		navigate('/dashboard/createaccountform');
	}

	useEffect(() => { 
		dispatch(createAccountSuccess(''));
		dispatch(createAccountFailure(''));

	});

	useEffect(() => {

		const pageNum = currentPageNumber;
		const pageSize = numberOfElementsonThisPage;
		const sortBy = sortConfig.key;
		const sortOrder =sortConfig.direction;
		const retriveMerchantInfoqueryParams= { pageNum, pageSize, sortBy, sortOrder };
		dispatch(getmerchantsInfoRequest(retriveMerchantInfoqueryParams));
	}, [dispatch,currentPageNumber, numberOfElementsonThisPage,sortConfig]);

	useEffect(() => {
		if (merchantsdataerror || !merchantsdata) {
			setTotalNumberOfPages(0);
			setTotalNumberOfElements(0);
		} else {
			// If data is available and there's no error, update states based on the data
			setTotalNumberOfPages(merchantsdata.totalPages || 0);
			setTotalNumberOfElements(merchantsdata.totalElements || 0);
		}
	}, [merchantsdata, merchantsdataerror]); 

	const handleCellClick = (rowData, columnKey) => {

		dispatch(activelocations(parseInt(rowData.locations)));
		//dispatch(activelocationslist(totaladdresslists));
		dispatch(activebusinessname(rowData.brandName));
		dispatch(activebrandid(rowData.brandId));
		//open view location details pop up
		if (columnKey === 'locations') {

			setShouldOpenModal(true);
			dispatch(getViewLocationDetailsRequest(rowData.brandId));

		} else if (columnKey === 'CreateAccountCTA') {

			dispatch(saveAggregatorValues(rowData.aggregator));
			dispatch(activebrandnames(rowData.brandName));

		}
	};

	function formatDate(inputDate) {
		const date = new Date(inputDate);
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const year = date.getFullYear();
		return `${month}/${day}/${year}`;
	}

	const enrichedMerchantsData = useMemo(() => {
		if (merchantsdata && merchantsdata.content) {
			let accountStatus ='';
			//&& orderHistoryData.orders && Array.isArray(orderHistoryData.orders.content)) {
			const storeOffsetMap = merchantsdata.storeOffsetMap;
			//setStoreOffset(storeOffsetMap);
			return merchantsdata.content.map(order => {
				
				const locationsCount = order.locations;
				const Status = order.isAccountCreated;
				const businessName = order.businessName;
				const MerchantbrandId = order.brandId;				

				if (Status === true && Status !== null) {
					accountStatus = 'Created';
				} else {
					accountStatus = 'Not Created';
				}

				// Timezone adjustment
				let adjustedOrderDate = formatDate(order.createdAt);
				
				// Return the enriched and adjusted order object
				let CreateAccountButtonComponent = null; 
				if (!Status) {
					CreateAccountButtonComponent = <CreateAccountButton  onClick={handleCreateAccountClick2}/>; // Enable the button
				}else{
					CreateAccountButtonComponent = 'Account Created';
				}
				return {
					...order,
					//customerName: customerName,
					locations: locationsCount+' locations',
					CreateAccountCTA : CreateAccountButtonComponent,
					isAccountCreated: accountStatus,
					createdAt: adjustedOrderDate,
					businessName: businessName,
					brandId: MerchantbrandId
				};
				
			});
		}
		return [];
	}, [merchantsdata]);
	

	return (
		<>
			<div className='managemerchant-container'>
				<Paper className='page-header'>
					<h4 className='title' data-testid='manage-merchants' >{MANAGE_MERCHANTS}</h4>
				</Paper>
			</div>
			<div className='managemerchant-body'>
				<div className='data-table'>
					<DataTable
						data={enrichedMerchantsData}
						columns={CREATE_ACC_COLOUMNS}
						tableName= {BUSINESSES_TEXT}
						tableSubTitle=''
						showAddToList={false}
						showTableFilter={false}
						hideSearchIfOneStoreSelected = {false}
						clickableColumnKey='locations'
						clickableColumnKey2='CreateAccountCTA'
						onSort={handleSort}
						sortConfig={sortConfig}
						includeCheckbox={false}
						onCellClick={handleCellClick}
						sortExcludeColumns={['locations', 'aggregator']}
						
					/>
					<div>
						<CustomPagination
							totalNumberOfPages={totalNumberOfPages}
							currentPageNumber={currentPageNumber}
							rowsPerPage={numberOfElementsonThisPage}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							rowsPerPageOptions={[10, 20, 50]}
						/>
					</div>
				</div>
			</div>
			<LocationsModal  open={modalOpen} onClose={handleCloseModal} />
		</>)
}

export default ManageMerchant;
